<template>
  <v-card class="elevation-4 mb-4">
    <v-card-text>
      <v-container fluid>
        <v-row no-gutters>
          <template v-for="mailEvent in mailEvents">
            <v-col class="mb-4">
              <stat-card :key="'card-' + mailEvent" :label="mailEvent" :value="periodStats[mailEvent].count"
                :percentage="periodStats[mailEvent].percent" useCampaignDecorators>
              </stat-card>
            </v-col>
          </template>
        </v-row>
      </v-container>
   </v-card-text>
   <v-card-title primary-title>
     <h3 class="text-h5 mb0">Lifetime Campaign Stats</h3>
   </v-card-title>
  </v-card>

</template>

<script>
import { mapState } from 'vuex'
import { StatsApi } from '@/services'
import * as R from 'ramda'
import { MAIL_EVENT_NAMES } from '@/constants'

import StatCard from '@/components/ui/StatCard'

export default {
  name: 'campaign-lifetime-stats',
  components: {
    [StatCard.name]: StatCard
  },
  props: {
    chartPrefix: {
      type: String,
      required: true
    },
    dealer: {
      type: Object,
      required: true
    },
    campaign: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      mailEvents: MAIL_EVENT_NAMES,
      campaignLifetimeStats: [] // data from api
    }
  },
  computed: {
    ...mapState({
      accountKey: state =>
        R.path(['attributes', 'custom:account_key'], state.cognito.user)
    }),
    periodStats() {
      const pdStats = this.campaignLifetimeStats.reduce((acc, eventStat) => {
        this.mailEvents.forEach(event => {
          const statCount = eventStat[event + '_count'] || 0
          acc[event] = acc[event] ? acc[event] : { count: 0 }
          acc[event].count += statCount
        })
        return acc
      }, {})

      // check to see if empty - 1st time through no data yet
      if (Object.keys(pdStats).length === 0) {
        // return a copy of everything initialized to 0
        return this.mailEvents.map(event => {
          return { [event]: { count: 0, percent: 0 } }
        }).reduce((acc, event) => {
          return { ...acc, ...event }
        }, {})
      } else {
        // run all calculations against the delivered count - delivered count is run only against sent
        const percentKeys = this.mailEvents.filter(event => !['sent', 'delivered'].includes(event))

        pdStats.delivered.percent = this.calculatePercentage(pdStats.delivered.count, pdStats.sent.count)
        percentKeys.forEach(event => {
          pdStats[event].percent = this.calculatePercentage(pdStats[event].count, pdStats.delivered.count)
        })
      }

      return pdStats
    },


  },
  watch: {
    campaign: function (newCampaign) {
      this.loadCampaignStats()
    }
  },
  methods: {
    loadCampaignStats () {
      const params = {
        account_key: this.accountKey,
        sender_key: this.dealer.dms_key,
        campaign_id: this.campaign.id
      }

      StatsApi.fetchDailyStats (params)
        .then(stats => {
          this.campaignLifetimeStats = stats
        })
        .catch(error => {
          this.$logger.error('Error loading Campaign Lifetime Stats from API', error.message)
          this.$flash({
            showClose: true,
            message: `Error loading Campaign Lifetime Stats from API: ${error.message}`,
            type: 'mini',
            duration: 3000
          })
        })
    },
    calculatePercentage(numerator, denominator) {
      if (denominator === 0) return 0.0; // Prevent division by zero
      return ((numerator / 1.0) / (denominator / 1.0))
    },

  }
}
</script>
